import { format } from "date-fns";
import { cs } from "date-fns/locale/cs";
import { parseTimelineDate } from "web_myplann/NotificationCenter/Utils/parseTimelineDate";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

export const formatTimelineSpacedDate = (isoDate: string): string =>
	format(parseTimelineDate(isoDate), DateFormat.DisplaySpaced, { locale: cs });
